import dayjs from 'dayjs';
import { TableCell, Booking } from './booking-types';
import dayOfYear from 'dayjs/plugin/dayOfYear';
dayjs.extend(dayOfYear);

export const applyBookings = (year: number, yearCells: TableCell[], bookings: Booking[]): TableCell[] => {
  const updatedYearCells = [...yearCells];

  bookings.forEach((booking) => {
    if (booking.startDate.substring(0, 4) === `${year}`) {
      const bookingStartDay = dayjs(booking.startDate, 'YYYYMMDD').dayOfYear();
      const bookingEndDay = dayjs(booking.endDate, 'YYYYMMDD').dayOfYear();

      for (let i = bookingStartDay; i <= bookingEndDay; i++) {
        switch (true) {
          case i === bookingStartDay:
            updatedYearCells[i - 1] = { day: ' ', status: `${updatedYearCells[i - 1].status.substring(0, 1)}s` };
            break;
          case i === bookingEndDay:
            updatedYearCells[i - 1] = { day: ' ', status: `e${updatedYearCells[i - 1].status.substring(1)}` };
            break;
          default:
            updatedYearCells[i - 1] = { day: ' ', status: `bb` };
        }
      }
    }
  });
  return updatedYearCells;
};
